<div class="operation-content">
  <div class="operation-controls">
    <y42-operation-input-operator-form-control
      [operatorControl]="form.controls.operator!"
      [operatorOptions]="state.operatorOptions"
    ></y42-operation-input-operator-form-control>

    <div *ngIf="state.isSingleValueOperation">
      <mat-form-field [style.fontSize]="'10px'" appearance="outline" class="w-full no-padding">
        <mat-label>Text</mat-label>
        <input
          matInput
          type="text"
          autocomplete="off"
          #autocompleteTrigger
          [matAutocompleteDisabled]="disableAutoComplete"
          [matAutocomplete]="autoCompleteInput"
          [ngModel]="form.controls.values.value[0]"
          (ngModelChange)="patchValues($event)"
          (keydown.enter)="closeAutocompletePanel()"
        />
        <div matSuffix class="relative">
          <button
            *ngIf="state.autoProposalLoaded && predefinedValues?.length"
            class="small-icon-button"
            mat-icon-button
            type="button"
            (click)="toggleAutocomplete()"
            [intercomTarget]="'01-operation-text-99946'"
            [matTooltip]="disableAutoComplete ? 'Enable Autocomplete' : 'Disable Autocomplete'"
          >
            <fa-icon
              class="fs-8 text-gray-700"
              [icon]="['fal', disableAutoComplete ? 'list-ul' : 'align-slash']"
            ></fa-icon>
          </button>
          <button
            class="small-icon-button"
            mat-icon-button
            type="button"
            *ngIf="!state.autoProposalLoading && !state.autoProposalLoaded"
            (click)="loadAutoProposal.emit(); setAutoProposalLoading()"
            [intercomTarget]="'01-operation-text-28429'"
            matTooltip="Load Auto Proposal"
          >
            <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'list-ul']"></fa-icon>
          </button>
          <mat-spinner
            [color]="'primary'"
            *ngIf="state.autoProposalLoading && !state.autoProposalLoaded"
            class="mt-1"
            [diameter]="18"
          >
          </mat-spinner>
        </div>
        <mat-autocomplete #autoCompleteInput="matAutocomplete">
          <mat-option
            *ngFor="let value of state.autocompleteValues; let i = index; trackBy: trackByValue"
            [value]="value"
          >
            <span class="fs-08">{{ value }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div *ngIf="state.isMultiValueOperation">
      <y42-operation-input-chip-list #operationInputChipList [valuesControl]="form.controls.values" [index]="index">
        <input
          *ngIf="operationInputChipList.chipList"
          #chipListInput
          [formControl]="valuesInputCtrl"
          type="text"
          [matChipInputFor]="operationInputChipList.chipList"
          [matChipInputSeparatorKeyCodes]="operationInputChipList.separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          [matAutocomplete]="autoCompleteInput"
          (matChipInputTokenEnd)="
            operationInputChipList.addChip(form.controls.operator?.value, $event.value, $event.input);
            valuesInputCtrl.reset()
          "
        />
        <mat-autocomplete
          #autoCompleteInput="matAutocomplete"
          (optionSelected)="
            operationInputChipList.addChip(form.controls.operator?.value, $event.option.value); valuesInputCtrl.reset()
          "
        >
          <mat-option
            *ngFor="let value of state.autocompleteValues; let i = index; trackBy: trackByValue"
            [value]="value"
          >
            <span class="fs-08">{{ value }}</span>
          </mat-option>
        </mat-autocomplete>
      </y42-operation-input-chip-list>

      <div matSuffix *ngIf="!state.autoProposalLoaded" class="relative">
        <button
          class="small-icon-button"
          mat-icon-button
          *ngIf="!state.autoProposalLoading"
          (click)="loadAutoProposal.emit(); setAutoProposalLoading()"
          [intercomTarget]="'01-operation-text-64326'"
          matTooltip="Load Auto Proposal"
        >
          <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'list-ul']"></fa-icon>
        </button>
        <mat-spinner [color]="'primary'" *ngIf="state.autoProposalLoading" class="mt-1" [diameter]="18"></mat-spinner>
      </div>
      <mat-hint> Press 'Enter' to select</mat-hint>
    </div>
  </div>

  <y42-operation-input-delete [index]="index" [columnType]="columnType"></y42-operation-input-delete>
</div>

<y42-operation-input-add
  [index]="index"
  [columnType]="columnType"
  [defaultOperator]="state.operatorOptions[0].value"
  [enableMoreConditions]="enableMoreConditions"
></y42-operation-input-add>
